<template>
    <div>
        <el-dialog :visible.sync="IsExportSetting" :modal-append-to-body="true" :append-to-body="true" width="800" :title="g('$导出设置')">
            <el-form ref="form" label-width="100px">
                <el-form-item :label="g('$字段列表')">
                    <el-tag class="TagItem" v-for="tag in Table.TableColumns" :closable="true" :disable-transitions="false" @close="handleClose(tag)">
                        {{tag.nickName}}
                    </el-tag>
                </el-form-item>
                <el-form-item :label="g('$导出条数')">
                    <el-input v-model="ExportNumber"></el-input>
                    <div class="bs-example bs-example-bg-classes" style="color:#666">{{g('$最大导出:') + MaxExportNumber}}</div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="text" size="large" @click="IsExportSetting=false">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large" @click="ToExport()">{{gets('$确定导出')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    //[{ToFun:function(callback){},CallBack:function(){} }]
    function ArrCallBack(arr, endcallback) {
        function ToCallBack(index) {
            arr[index].ToFun(function(data, error) {
                if (error) {
                    endcallback(error)
                    return;
                }
                arr[index].CallBack(data, error)
                if (index >= arr.length - 1) {
                    endcallback(error)
                } else {
                    index++;
                    ToCallBack(index)
                }
            })
        }
        if (arr.length > 0) {
            ToCallBack(0)
        }
    }
    import gets from '@/model/language'
    import FileSaver from 'file-saver'
    import {
        IsRights,
        Modulel,
        Permission,
        Clone,
        ToComponentData,
        ToSubmitEntity,
        CheckByConfig,
        ToSubmitData,
        CheckByEntity,
        $Urlpath,
        toSelect
    } from '@/config/config'
    export default {
        //props: ['TableConfig', 'SearchEntity', 'PageSizeFieldName', 'PageIndexFieldName', 'MaxExportCount'],
        data() {
            return {
                IsExportSetting: false,
                Table: null,
                ExportNumber: 2000,
                MaxExportNumber: 20000,
                SearchEntity: null,
                PageSizeFieldName: '',
                PageIndexFieldName: '',
                MaxExportCount: 20000,
                SearchFunction: null
            }
        },
        created() {
            if (this.MaxExportCount) {
                this.MaxExportNumber = this.MaxExportCount;
            }
        },
        methods: {
            g: gets,
            gets: gets,
            //
            Show(TableConfig, SearchEntity, SearchFunction, PageSizeFieldName, PageIndexFieldName, MaxExportCount) {
      
                var t = Clone(TableConfig);
                var arr = [];
                //过滤无用的列
                for (var i of t.TableColumns) {
                    if (i.type != 'selection' && i.type != 'Operation' && i.type != 'expand') {
                        arr.push(i)
                    }
                }
                t.TableColumns = arr;
                this.$set(this.$data, 'Table', t)
                this.$set(this.$data, 'SearchEntity', SearchEntity)
                this.$set(this.$data, 'SearchFunction', SearchFunction)
                this.$set(this.$data, 'PageSizeFieldName', PageSizeFieldName ? PageSizeFieldName : 'PageSize')
                this.$set(this.$data, 'PageIndexFieldName', PageIndexFieldName ? PageIndexFieldName : 'PageIndex')
                if (MaxExportCount) {
                    this.MaxExportNumber = MaxExportCount;
                }
                this.MaxExportCount = MaxExportCount;
                this.IsExportSetting = true;
            },
            //
            ShowByConfig(Config,MaxExportCount) {
                var t = Clone(Config.Table);
                var arr = [];
                //过滤无用的列
                for (var i of t.TableColumns) {
                    if (i.type != 'selection' && i.type != 'Operation' && i.type != 'expand') {
                        arr.push(i)
                    }
                }

                t.TableColumns = arr;
                this.$set(this.$data, 'Table', t)
                this.$set(this.$data, 'SearchEntity', Config.SearchEntity)
                this.$set(this.$data, 'SearchFunction', Config.SearchPageData)
                this.$set(this.$data, 'PageSizeFieldName', 'PageSize')
                this.$set(this.$data, 'PageIndexFieldName',  'PageIndex')
                if (MaxExportCount) {
                    this.MaxExportNumber = MaxExportCount;
                }
                this.MaxExportCount = MaxExportCount;
                this.IsExportSetting = true;
            },
            Hide() {
                this.IsExportSetting = false;
            },
            handleClose(tag) {
                this.Table.TableColumns.splice(this.Table.TableColumns.indexOf(tag), 1);
            },
            getDataForPath(d, path) {
                var todata = d;
                var ps = path.split('.')
                for (var i of ps) {
                    try {
                        todata = todata[i];
                    } catch (error) {
                        return '';
                    }
                }
                return todata;
            },
            AddString(c, fieldName) {
                var ds = (fieldName + "").split(',')
                var str = '';
                for (var index = 0; index < ds.length; index++) {
                    var element = ds[index];
                    str += this.getDataForPath(c, element)
                }
                return str;
            },
            AddLanguageString(c, fieldName) {
                var ds = (fieldName + "").split(',')
                var str = this.getDataForPath(c, ds[0]);
                if (ds.length > 0) {
                    str += "(" + this.getDataForPath(c, ds[1]) + ")"
                }
                return str;
            },
            ToExport() {
                var self = this
                if (self.MaxExportNumber < self.ExportNumber) {
                    self.$message.success(self.g("$导出数量不能大于最大导出数量"))
                    return;
                }
                var ExportNumber = self.ExportNumber;
                var yps = self.SearchEntity[self.PageSizeFieldName];
                var ypi = self.SearchEntity[self.PageIndexFieldName];
                self.SearchEntity[self.PageSizeFieldName] = ExportNumber;
                self.SearchEntity[self.PageIndexFieldName] = 1;
                var datas = [];
                var PageCount = 1;
                var PageSize = 20000;
                window.IsNotRootSet = true;
                self.SearchFunction(function(d) {
                    if (d && !d.Message) {
                        if (d.PageCount) { //如果是分页
                            PageCount = d.PageCount;
                            for (var i of d.Records) {
                                datas.push(i)
                            }
                            PageSize = d.Records.length;
                        } else { //如果是不是分页
                            PageCount = 1;
                            for (var i of d) {
                                datas.push(i)
                            }
                        }
                        if (PageCount > 1) {
                            var arr = [];
                            var en = ExportNumber;
                            if (d.TotalCount < ExportNumber) {
                                en = d.TotalCount;
                            }
                            var PCount = en % PageSize == 0 ? en / PageSize : (en / PageSize) + 1;
                            for (var k = 2; k < PCount; k++) {
                                const i = k;
                                arr.push({
                                    ToFun: function(callback) {
                                        self.SearchEntity[self.PageSizeFieldName] = PCount == i ? (en % PageSize == 0 ? 0 : en % PageSize) : PageSize;
                                        self.SearchEntity[self.PageIndexFieldName] = i;
                                        self.SearchFunction(function(ddd) {
                                            if (ddd && !ddd.Message) {
                                                callback(ddd, '')
                                            }
                                            if (ddd.Message) {
                                                callback(ddd, data.Message)
                                            }
                                        });
                                    },
                                    CallBack: function(data) {
                                        for (var j of data.Records) {
                                            datas.push(j)
                                        }
                                    }
                                })
                            }
                            ArrCallBack(arr, function(error) {
                                window.IsNotRootSet = false;
                                self.ToExcel(datas)
                            })
                        } else {
                            window.IsNotRootSet = false;
                            self.ToExcel(datas)
                        }
                    } else {
                        window.IsNotRootSet = false;
                        self.$message.success(d.Message)
                    }
                })
            },
            ToExcel(datas) {
                var self = this

                var titles =[];

                for(var item of this.Table.TableColumns){
                    titles.push(item.nickName)
                }

                var title = titles.join(',')+"\r\n"

                var content ="";
                for(var data of datas){
                    var idatas = []
                    for(var item of this.Table.TableColumns){
                        var d = "";
                        if(item.type=='String'){
                            d = self.getDataForPath(data,item.field);
                        }

                        if(item.type=='AddString'){
                            d = item.AddString?item.AddString(data,item): self.AddString(data,item.field)
                        }

                        if(item.type=='AddLanguageString'){
                            d = self.AddLanguageString(data,item.field)
                        }


                        if(item.type=='Int'){
                            d = self.getDataForPath(data,item.field);
                        }

                        if(item.type=='DateTime'){
                            d = self.getDataForPath(data,item.field);
                        }

                        if(item.type=='Select'){
                            d =  toSelect(self.getDataForPath(data,item.field),item.forSelectStoreName);
                        }



                        if(item.type=='Boolean'){
                            d =  toSelect(self.getDataForPath(data,item.field),item.forSelectStoreName);
                        }


                        if(item.type=='Image'){
                            d = self.getDataForPath(data,item.field);
                        }

                        if(item.type=='Input'){
                            d = self.getDataForPath(data,item.field);
                        }

                        if(d&& (d+"").indexOf(',')!=-1){
                            if((d+"").indexOf('"')!=-1){
                                 d= "\""+d.replace(/\"/,"\"\"")+"\""
                            }else{
                                 d= "\""+d+"\""
                            }

                        }
                        idatas.push(d)
                    }
                    content+= idatas.join(',')+"\r\n"
                }


                var blob = new Blob(['\ufeff'+title+content], {
                    type: "text/plain;charset=utf-8"
                });

                var timestamp=new Date().getTime();
                FileSaver.saveAs(blob, "export_"+timestamp+".csv");

            }
        }
    }
</script>

<style>
    .TagItem {
        margin-right: 10px;
    }
</style>
















// WEBPACK FOOTER //
// table_export.vue?719f17eb